export interface ITupleResponseDTO {
  key: string;
  value: string;
}
